import React from 'react'

import { useMobile } from 'hooks/ua'

import vipNode from 'images/vip-node.jpg'
import vipLite from 'images/vip-lite.jpg'
import ContactItem from './ContactItem'

import styles from './style.less'

export default function Contact() {
  const isMobile = useMobile()

  return (
    <div className={isMobile ? styles.mobileContact : styles.pcContact}>
      <ContactItem icon={vipNode} title="我有上行带宽大于1G的大节点资源" />
      <ContactItem icon={vipLite} title="我有小盒子资源，扫她" />
    </div>
  )
}
